import { render, staticRenderFns } from "./addCategory.vue?vue&type=template&id=4aa076ee&scoped=true&"
import script from "./addCategory.vue?vue&type=script&lang=js&"
export * from "./addCategory.vue?vue&type=script&lang=js&"
import style0 from "./addCategory.vue?vue&type=style&index=0&id=4aa076ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa076ee",
  null
  
)

export default component.exports